<div class="editor">
  <div class="editable-container" contenteditable="true"
    (focus)="onEditorFocus($event)"
    (blur)="onEditorBlur($event)"
    (input)="onEditorInput($event)"
    (click)="onEditorClick($event)" #editorAreaEl>
  </div>
  <textarea [ngClass]="{'visible': showCode }" (input)="updateHTML($event)" *ngIf="showCode">{{ innerHTML }}</textarea>
  <app-resizer
    [resizableElement]="resizableElement"
    (removeResizable)="removeResizable()"
    *ngIf="!!resizableElement" #resizer>
  </app-resizer>
</div>
